<template>
  <div class="sale-detail-page" v-loading="pageLoading" :element-loading-text="$t('sale.common.loading')">
    <div class="sale-page-header">
      <div class="sale-page-header__top">
        <div class="sale-page-header__left">
          <el-button
            class="sale-back-btn"
            size="small"
            icon="el-icon-arrow-left"
            @click="goBack"
            >{{ $t('sale.detail.back') }}</el-button
          >
          <h2 class="sale-page-title">{{ $t('sale.detail.title') }}</h2>
          <span class="sale-page-desc" v-if="creatData.bill && creatData.bill.name">{{ $t('sale.detail.batch') }}{{ creatData.bill.name }}</span>
        </div>
      </div>
    </div>

    <section class="sale-panel sale-panel--info" v-if="creatData.bill && creatData.bill.id">
      <div class="sale-panel__head">
        <span>{{ $t('sale.detail.orderInfo') }}</span>
      </div>
      <ul class="sale-info-grid">
        <li v-if="isCategoryOne">
          <label>{{ $t('sale.order.visaCenter') }}</label>
          <span>{{ visaCenterDisplay }}</span>
        </li>
        <li>
          <label>{{ $t('sale.detail.productList') }}</label>
          <span>{{ creatData.product ? $tCommodityName(creatData.product.name) : $t('sale.common.none') }}</span>
        </li>
        <li>
          <label>{{ $t('sale.detail.financeStatus') }}</label>
          <span class="sale-status">{{ billingState[creatData.bill.billingState] }}</span>
        </li>
        <li>
          <label>{{ $t('sale.detail.saleTime') }}</label>
          <span>{{ setTime(creatData.bill.createAt) }}</span>
        </li>
        <li>
          <label>{{ $t('sale.detail.orderNo') }}</label>
          <span>{{ creatData.bill.billingNo }}</span>
        </li>
        <li>
          <label>{{ $t('sale.detail.buyQty') }}</label>
          <span>{{ allpage }}{{ $t('sale.common.unitGe') }}</span>
        </li>
        <li v-if="tableData[0] && tableData[0].orderType != 2">
          <label>{{ $t('sale.detail.download') }}</label>
          <span class="blue" @click="downPdf">{{ $t('op.downloadCredential') }}</span>
        </li>
        <li v-else>
          <span v-if="gridData != null">
            <label>{{ $t('sale.detail.download') }}</label>
            <span
              v-if="gridData.length != 0"
              class="blue"
              @click="tdDownPdf"
              >{{ $t('op.downloadCredential') }}</span
            ><span v-else class="sale-disabled-link">{{ $t('op.downloadCredential') }}</span>
          </span>
        </li>
        <!-- <li v-if="creatData.bill.orderType != 2">
          备注：<span>{{ creatData.bill.remark || "无" }}</span>
        </li> -->
        <li v-if="tableData[0] && tableData[0].extra">
          <span v-if="JSON.parse(tableData[0].extra).reference">
            <label>{{ $t('sale.detail.referrer') }}</label>
            <span>{{ JSON.parse(tableData[0].extra).reference }}</span>
          </span>
        </li>
        <li v-if="tableData[0] && tableData[0].extra">
          <span v-if="JSON.parse(tableData[0].extra).reference">
            <label>{{ $t('sale.detail.decorationCo') }}</label>
            <span>{{ JSON.parse(tableData[0].extra).decoration }}</span>
          </span>
        </li>
        <li v-if="tableData[0] && tableData[0].extra">
          <span v-if="JSON.parse(tableData[0].extra).reference">
            <label>{{ $t('sale.detail.decorationAddr') }}</label>
            <span>{{ JSON.parse(tableData[0].extra).address }}</span>
          </span>
        </li>
        <li v-if="tableData[0] && tableData[0].extra">
          <span v-if="JSON.parse(tableData[0].extra).reference">
            <label>{{ $t('sale.detail.houseNo') }}</label>
            <span>{{ JSON.parse(tableData[0].extra).houseNumber }}</span>
          </span>
        </li>
        <li v-if="tableData[0] && tableData[0].extra">
          <span v-if="JSON.parse(tableData[0].extra).reference">
            <label>{{ $t('sale.detail.contractAmount') }}</label>
            <span>{{ JSON.parse(tableData[0].extra).contractAmount }}</span>
          </span>
        </li>
        <li v-if="creatData.bill.orderType == 3">
          <label>{{ $t('sale.detail.groupCredential') }}</label>
          <a
            v-if="creatData.bill.serviceCredential"
            :href="creatData.bill.serviceCredential"
            target="_blank"
            class="blue"
            >{{ $t('op.viewCredential') }}</a
          >
          <span v-else>--</span>
        </li>
      </ul>
    </section>

    <div class="searchBox" v-if="false">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="快捷搜索">
          <el-input
            style="width: 400px"
            v-model="formInline.text"
            type="text"
            placeholder="手机号 / 证件号"
          ></el-input>
        </el-form-item>
        <el-button class="text2" type="primary" @click="seachBox"
          >搜索</el-button
        >
      </el-form>
    </div>

    <section class="sale-panel sale-panel--table">
      <div class="sale-panel__head">
        <span>{{ $t('sale.detail.coverage') }}</span>
        <span class="sale-panel__count">{{ $t('sale.order.total', { n: allpage }) }}</span>
      </div>
    <div class="zsh" v-if="$route.query.type == 'type'">
     
        <div class="table">
          <el-table
            :data="tableData"
            row-key="id"
            style="width: 100%; font-size: 14px"
            height="100%"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :data="props.row.parentDetail"
                  v-if="
                    props.row.parentDetail[0] != undefined &&
                    props.row.parentDetail[0] != null
                  "
                  stripestyle="width: 100%"
                >
                  <el-table-column
                    width="180"
                    prop="name"
                    show-overflow-tooltip
                    :label="$t('col.name')"
                  ></el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('col.mobile')">
                    <template slot-scope="scope">
                      <!-- {{props.row.parentDetail[0]}} -->
                      <span>{{
                        props.row.parentDetail[0].mobileno || "--"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="160"
                    show-overflow-tooltip
                    :label="$t('col.idNo')"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        props.row.parentDetail[0].nationalId || "待激活"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('col.validFrom')">
                    <template slot-scope="scope">
                      <span>{{
                        props.row.parentDetail[0].validFrom
                          ? setTime(props.row.parentDetail[0].validFrom)
                          : "--"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('col.validUtil')">
                    <template slot-scope="scope">
                      <span>{{
                        props.row.parentDetail[0].validUtil
                          ? setTime(props.row.parentDetail[0].validUtil - 1000)
                          : "--"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip :label="$t('col.policyNo')">
                    <template slot-scope="scope">
                     
                      <span v-if="scope.row.productId == '512' || scope.row.productId == '513' || scope.row.productId == '514'">
                        <span >--</span>
                      </span>
                      <span v-else>
                        <span v-if="!props.row.parentDetail[0].policyNo">--</span>
                      <a
                        v-else
                        :href="props.row.parentDetail[0].policyUrl"
                        target="_blank"
                        class="blue"
                        >{{ props.row.parentDetail[0].policyNo }}</a
                      >
                      </span>
                      
                    </template>
                  </el-table-column>

                  <el-table-column :label="$t('col.op')">
                    <template slot-scope="scope">
                      <a
                        v-if="props.row.parentDetail[0].serviceCredential"
                        :href="props.row.parentDetail[0].serviceCredential"
                        target="_blank"
                        class="blue"
                        >{{ $t('op.viewCredential') }}</a
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column :label="$t('col.userName')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.name || "待激活" }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('col.mobile')" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.mobileno || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              :label="$t('col.idNo')"
              align="center"
              width="170"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.nationalId || "待激活" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              :label="$t('col.validFrom')"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.validFrom ? setTime(scope.row.validFrom) : "--"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              :label="$t('col.validUtil')"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{
                    scope.row.validUtil
                      ? setTime(scope.row.validUtil - 1000)
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              prop="policyNo"
              :label="$t('col.policyNo')"
              align="center"
              width="190px"
            >
              <template slot-scope="scope">
               
                <span v-if="scope.row.productId == '512' || scope.row.productId == '513' || scope.row.productId == '514'">
                  <span >--</span>
                </span>
                <span v-else>
                  <span v-if="!scope.row.policyNo">--</span>
                  <a
                    v-else
                    :href="scope.row.policyUrl"
                    target="_blank"
                    class="blue"
                    >{{ scope.row.policyNo }}</a
                  >
                </span>
                
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('col.remark')"
              v-if="creatData.product.productGroup == 'G197'"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.resident }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="
                creatData.product.productGroup == 'G67' ||
                creatData.product.productGroup == 'G70' ||
                creatData.product.productGroup == 'G75' ||
                creatData.product.productGroup == 'G76'
              "
              :label="$t('form.resident').replace(/:$/, '')"
            >
              <template slot-scope="scope">
                <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
                <span>{{ scope.row.resident }}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="creatData.product.productGroup == 'G74'"
              :label="$t('col.flightNo')"
            >
              <template slot-scope="scope">
                <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
                <span>{{ scope.row.resident }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="divisionDay == 1 || divisionDay == 3"
              :label="$t('col.days')"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.continueDay }}日</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('col.op')" align="center" width="300">
              <template slot-scope="scope">
                <span class="yellow">{{
                  billingState[scope.row.billingState]
                }}</span>
                <el-tooltip effect="dark" content="请先激活" placement="top">
                  <span
                    v-if="!scope.row.validFrom"
                    style="color: #ccc; cursor: pointer"
                    >{{ $t('op.viewCredential') }}</span
                  >
                </el-tooltip>
                <template v-if="scope.row.validFrom">
                  <el-button
                    v-if="!scope.row.serviceCredential"
                    type="text"
                    disabled
                    ><i class="el-icon-loading"></i>{{ $t('op.genCredential') }}</el-button
                  >
                  <a
                    v-if="scope.row.serviceCredential"
                    :href="scope.row.serviceCredential"
                    target="_blank"
                    class="blue"
                    >{{ $t('op.viewCredential') }}</a
                  >
                </template>
                <!-- <template >
							<el-button  type='text' >下载发票</el-button>
						</template> -->

                <template>
                  <span v-if="scope.row.orderType != 3">
                  <el-button
                    v-if="
                      scope.row.billingState == 0 ||
                      scope.row.billingState == 4 ||
                      (scope.row.validFrom &&
                        scope.row.validFrom < scope.row.nowTime)
                    "
                    type="text"
                    disabled
                    >{{ $t('op.refund') }}</el-button
                  >
                  <!-- <el-button v-else-if='scope.row.validFrom != undefined && scope.row.parentId != null' type='text' disabled>{{ $t('op.refund') }}</el-button> -->
                  <el-button
                    v-else
                    type="text"
                    @click="
                      centerDialogVisible = true;
                      exitData = scope.row;
                    "
                    >{{ $t('op.refund') }}</el-button
                  >
                  </span>
                  <!-- <el-button  type='text' @click='centerDialogVisible=true;exitData=scope.row'>{{ $t('op.refund') }}</el-button> -->
                  <!-- <span v-if="scope.row.product.includeInsurance == 0">
                <el-button v-if="scope.row.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
                </template>

                <!-- <el-button v-if="scope.row.validFrom != undefined&&">开发票</el-button>
						<el-button v-else type='text'>开发票</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="creatData.details && creatData.details[0] && creatData.details[0].extra">
        <div><b>其他信息</b></div>
        <div>
          所属集体二级企业:{{
            JSON.parse(creatData.details[0].extra).companyName
          }}
        </div>
        <div>
          投保人:{{ JSON.parse(creatData.details[0].extra).insureName }}
        </div>
        <div>
          项目名称:{{ JSON.parse(creatData.details[0].extra).projectName }}
        </div>
        <div>
          职业:{{ JSON.parse(creatData.details[0].extra).occupationName }}
        </div>
        <div>外派国家:{{ creatData.details[0].resident }}</div>
        <div>保险起期:{{ setTime(creatData.details[0].validFrom) }}</div>
        <div>
          保险月份:{{ JSON.parse(creatData.details[0].extra).insredMonth }}
        </div>
      </div>
    </div>
    <div class="sale-table-wrap" v-else>
      <div class="table">
        <el-table
          :data="tableData"
          row-key="id"
          style="width: 100%"
          height="100%"
        >
          <!-- <el-table-column :label="$t('col.userName')" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.detail.name || '待激活'}}</span>
					</template>
				</el-table-column>
			
				<el-table-column :label="$t('col.mobile')" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.detail.mobileno || '--'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('col.idNo')" align='center' width="170">
					<template slot-scope="scope">
						<span>{{scope.row.detail.nationalId || '待激活'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('col.validFrom')" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.detail.validFrom? setTime(scope.row.detail.validFrom) :'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('col.validUtil')" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.detail.validUtil ? setTime(scope.row.detail.validUtil - 1000) :'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="policyNo" :label="$t('col.policyNo')" align='center' width="190px">
					<template slot-scope="scope">
						<span v-if="!scope.row.detail.policyNo">--</span>
						<a v-else :href="scope.row.detail.policyUrl" target="_blank" class="blue">{{scope.row.detail.policyNo}}</a>
					</template>
				</el-table-column>
				<el-table-column :label="$t('col.op')" align='center' width="300">
					<template slot-scope="scope">
						<span class="yellow">{{billingState[scope.row.detail.billingState]}}</span>
						<el-tooltip effect="dark" content="请先激活" placement="top">
							<span v-if="!scope.row.detail.validFrom" style="color: #ccc;cursor: pointer;">{{ $t('op.viewCredential') }}</span>
						</el-tooltip>
						<template v-if="scope.row.detail.validFrom">
							<el-button v-if="!scope.row.detail.serviceCredential"  type='text' disabled><i class="el-icon-loading"></i>{{ $t('op.genCredential') }}</el-button>
							<a v-if="scope.row.detail.serviceCredential" :href="scope.row.detail.serviceCredential" target="_blank" class="blue">{{ $t('op.viewCredential') }}</a>
						</template>
            <template>
              <el-button v-if='scope.row.detail.billingState == 0 || scope.row.detail.billingState == 4 || (scope.row.detail.validFrom && scope.row.detail.validFrom < scope.row.detail.nowTime)' type='text' disabled>{{ $t('op.refund') }}</el-button>
              <el-button v-else type='text' @click='centerDialogVisible=true;exitData=scope.row'>{{ $t('op.refund') }}</el-button>
               <span v-if="scope.row.product.includeInsurance == 0">
                <el-button v-if="scope.row.detail.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.parentDetail"
                v-if="props.row.parentDetail[0] != undefined"
                stripestyle="width: 100%"
              >
                <el-table-column
                  width="180"
                  prop="name"
                  show-overflow-tooltip
                  :label="$t('col.name')"
                ></el-table-column>
                <el-table-column show-overflow-tooltip :label="$t('col.mobile')">
                  <template slot-scope="scope">
                    <!-- {{props.row.parentDetail[0]}} -->
                    <span>{{
                      props.row.parentDetail[0].mobileno || "--"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="160"
                  show-overflow-tooltip
                  :label="$t('col.idNo')"
                >
                  <template slot-scope="scope">
                    <span>{{
                      props.row.parentDetail[0].nationalId || "待激活"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip :label="$t('col.validFrom')">
                  <template slot-scope="scope">
                    <span>{{
                      props.row.parentDetail[0].validFrom
                        ? setTime(props.row.parentDetail[0].validFrom)
                        : "--"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip :label="$t('col.validUtil')">
                  <template slot-scope="scope">
                    <span>{{
                      props.row.parentDetail[0].validUtil
                        ? setTime(props.row.parentDetail[0].validUtil - 1000)
                        : "--"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip :label="$t('col.policyNo')">
                  <template slot-scope="scope">
                    
                    <span v-if="scope.row.productId == '512' || scope.row.productId == '513' || scope.row.productId == '514'">
                  <span >--</span>
                </span>
                <span v-else>
                  <span v-if="!props.row.parentDetail[0].policyNo">--</span>
                    <a
                      v-else
                      :href="props.row.parentDetail[0].policyUrl"
                      target="_blank"
                      class="blue"
                      >{{ props.row.parentDetail[0].policyNo }}</a
                    >
                </span>
                    
                  </template>
                </el-table-column>

                <el-table-column :label="$t('col.op')">
                  <template slot-scope="scope">
                    <a
                      v-if="props.row.parentDetail[0].serviceCredential"
                      :href="props.row.parentDetail[0].serviceCredential"
                      target="_blank"
                      class="blue"
                      >{{ $t('op.viewCredential') }}</a
                    >
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column :label="$t('col.userName')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name || "待激活" }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('col.mobile')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.mobileno || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            :label="$t('col.idNo')"
            align="center"
            width="170"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.nationalId || "待激活" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            :label="$t('col.validFrom')"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.validFrom ? setTime(scope.row.validFrom) : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            :label="$t('col.validUtil')"
            align="center"
          >
            <template slot-scope="scope">
              <span
                >{{
                  scope.row.validUtil
                    ? setTime(scope.row.validUtil - 1000)
                    : "--"
                }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            prop="policyNo"
            :label="$t('col.policyNo')"
            align="center"
            width="190px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.productId == '512' || scope.row.productId == '513' || scope.row.productId == '514'">
                  <span >--</span>
                </span>
                <span v-else>
                  <span v-if="!scope.row.policyNo">--</span>
              <a
                v-else
                :href="scope.row.policyUrl"
                target="_blank"
                class="blue"
                >{{ scope.row.policyNo }}</a
              >
              </span>
              
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('col.remark')"
            v-if="creatData.product.productGroup == 'G197'"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.resident }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="
              creatData.product.productGroup == 'G67' ||
              creatData.product.productGroup == 'G70' ||
              creatData.product.productGroup == 'G75' ||
              creatData.product.productGroup == 'G76'
            "
            :label="$t('form.resident').replace(/:$/, '')"
          >
            <template slot-scope="scope">
              <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
              <span>{{ scope.row.resident }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="creatData.product.productGroup == 'G74'"
            :label="$t('col.flightNo')"
          >
            <template slot-scope="scope">
              <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
              <span>{{ scope.row.resident }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="divisionDay == 1 || divisionDay == 3"
            :label="$t('col.days')"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.continueDay }}日</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('col.op')" align="center" width="300">
            <template slot-scope="scope">
              <span class="yellow">{{
                billingState[scope.row.billingState]
              }}</span>
              <el-tooltip effect="dark" content="请先激活" placement="top">
                <span
                  v-if="!scope.row.validFrom"
                  style="color: #ccc; cursor: pointer"
                  >{{ $t('op.viewCredential') }}</span
                >
              </el-tooltip>
              <template v-if="scope.row.validFrom">
                <el-button
                  v-if="!scope.row.serviceCredential"
                  type="text"
                  disabled
                  ><i class="el-icon-loading"></i>{{ $t('op.genCredential') }}</el-button
                >
                <a
                  v-if="scope.row.serviceCredential"
                  :href="scope.row.serviceCredential"
                  target="_blank"
                  class="blue"
                  >{{ $t('op.viewCredential') }}</a
                >
              </template>
              <!-- <template >
							<el-button  type='text' >下载发票</el-button>
						</template> -->

              <template>
                <span v-if="scope.row.orderType != 3">
                <el-button
                  v-if="
                    scope.row.billingState == 0 ||
                    scope.row.billingState == 4 ||
                    (scope.row.validFrom &&
                      scope.row.validFrom < scope.row.nowTime)
                  "
                  type="text"
                  disabled>{{ $t('op.refund') }}</el-button
                >
                <!-- <el-button v-else-if='scope.row.validFrom != undefined && scope.row.parentId != null' type='text' disabled>{{ $t('op.refund') }}</el-button> -->
                <el-button
                  v-else
                  type="text"
                  @click="
                    centerDialogVisible = true;
                    exitData = scope.row;
                  "
                  >{{ $t('op.refund') }}</el-button
                >
              </span>
                <!-- <el-button  type='text' @click='centerDialogVisible=true;exitData=scope.row'>{{ $t('op.refund') }}</el-button> -->
                <!-- <span v-if="scope.row.product.includeInsurance == 0">
                <el-button v-if="scope.row.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
              </template>

              <!-- <el-button v-if="scope.row.validFrom != undefined&&">开发票</el-button>
						<el-button v-else type='text'>开发票</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="fenye" v-if="$route.query.type != 'type'">
      
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allpage">
      </el-pagination>
    </div>
    </section>

    <el-dialog
      :title="$t('dialog.tip')"
      :visible.sync="centerDialogVisible"
      width="420px"
      center
      custom-class="sale-dialog sale-dialog--tip"
    >
      <div class="sale-dialog-tip sale-dialog-tip--warn">{{ $t('dialog.confirmRefund') }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{ $t('op.cancel') }}</el-button>
        <el-button type="primary" @click="sureExit">{{ $t('op.confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('dialog.friendTip')"
      :visible.sync="centerDialogVisible1"
      width="480px"
      center
      custom-class="sale-dialog sale-dialog--tip"
    >
      <div class="sale-dialog-tip">{{ $t('dialog.refundSuccess') }}</div>
      <refundDialog
        v-if="exitData && (exitData.fpdm || exitData.fphm)"
        :fpdm="exitData.fpdm"
        :fphm="exitData.fphm"
        :prodectName="creatData.product && creatData.product.name"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible1 = false"
          >{{ $t('op.confirm') }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 变更 -->
    <el-dialog
      title="更改保障人"
      :visible.sync="dialogFormVisible"
      width="560px"
      custom-class="sale-dialog sale-dialog--form"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('col.name')" prop="name">
          <el-input :disabled="disabled" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('col.mobile')" prop="mobileno">
          <el-input :disabled="disabled" v-model="ruleForm.mobileno"></el-input>
        </el-form-item>
        <el-form-item :label="$t('col.idNoShort')" prop="nationalId">
          <el-input
            :disabled="disabled"
            v-model="ruleForm.nationalId"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('form.activateDate')" prop="validFrom">
          <el-col :span="12">
            <el-date-picker
              :disabled="disabled"
              v-model="ruleForm.validFrom"
              type="datetime"
              :picker-options="pickerOptions"
              value-format="timestamp"
              :placeholder="$t('form.selectDate')"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('col.birthday')" prop="birthday">
          <el-col :span="11">
            <el-date-picker
              :disabled="disabled"
              v-model="ruleForm.birthday"
              type="date"
              value-format="timestamp"
              :placeholder="$t('form.selectDate')"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('col.sex')" prop="sex">
          <el-radio-group v-model="ruleForm.sex" :disabled="disabled">
            <el-radio label="M">{{ $t('form.male') }}</el-radio>
            <el-radio label="F">{{ $t('form.female') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('op.cancel') }}</el-button>
        <el-button
          v-if="disabledif"
          type="primary"
          @click="submitForm('ruleForm')"
          >{{ $t('op.confirm') }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 凭证下载入口 -->
    <el-dialog
      :title="$t('dialog.credentialDownload')"
      :visible.sync="dialogTableVisible"
      width="640px"
      custom-class="sale-dialog"
    >
      <el-table :data="gridData">
        <el-table-column :label="$t('sale.detail.credentialType')" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.scOpType == 1">{{ $t('sale.detail.groupCredential') }}</span>
            <span v-else-if="scope.row.scOpType == 2">{{ $t('sale.detail.groupCredentialEdit') }}</span>
            <span v-else-if="scope.row.scOpType == 3">{{ $t('sale.detail.groupCredentialReduce') }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('sale.detail.genDate')" width="200">
          <template slot-scope="scope">
            <span>{{ setTime(scope.row.createAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="address" :label="$t('col.op')">
          <template slot-scope="scope">
            <el-button type="text" @click="see(scope.row.scUrl)"
              >{{ $t('op.view') }}</el-button
            >
            <!-- <el-button style="margin-left:0px"  type='text' @click="download(scope.row);">下载</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderbillDetail,
  listByDetail,
  refund,
  searchBill,
  getPCActivateSign,
  downloadPdf,
  salechangeBillInfo,
  orderDetail,
} from "@/axios/api.js";
import common from "@/assets/common.js";
import Clipboard from "clipboard";
import { Loading } from "element-ui";
import axios from "axios";
import refundDialog from "@/components/refundDialog";
export default {
  data() {
    return {
      dialogTableVisible: false,
      gridData: [],
      channeID: "",
      divisionDay: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      includeInsurance: "",
      dialogFormVisible: false,
      currentBillId: "",
      // 更改保障人
      ruleForm: {
        name: "",
        mobileno: "",
        nationalId: "",
        validFrom: "",
        birthday: "",
        sex: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        mobileno: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
        nationalId: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          { min: 18, max: 18, message: "请输入正确证件号", trigger: "blur" },
        ],
        validFrom: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        birthday: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        desc: [{ required: true, message: "", trigger: "blur" }],
      },
      disabledif: true,
      disabled: false,
      searchText: "",
      tableData: [],
      tableData4: [],
      formInline: {
        text: "",
      },
      creatData: {
        bill: {},
        channel: {},
        product: {},
        saleUser: {},
      },
      centerDialogVisible: false,
      centerDialogVisible1: false,
      exitData: {},
      pageLoading: false,
      allpage: 0, //数据总数
      eachPage: 10, //每页
      indexPage: 0, //当前页
      timer: null,
      fuzhiData: "",
    };
  },
  components: {
    refundDialog,
  },
  computed: {
    /**
     * getInfo.category === 1（机构类型）
     * @returns {boolean}
     */
    isCategoryOne() {
      return String(window.localStorage.getItem('category')) === '1'
    },
    /**
     * 签证中心展示：优先取列表页传入的 query.visaCenter
     * @returns {string}
     */
    visaCenterDisplay() {
      var fromList = this.$route.query.visaCenter
      if (fromList != null && String(fromList).trim() !== '') {
        return fromList
      }
      return (this.creatData.saleUser && this.creatData.saleUser.name) || '--'
    },
    /**
     * 财务状态文案（随语言切换更新）
     * @returns {string[]}
     */
    billingState() {
      void this.appLocale;
      return [
        this.$t("billing.0"),
        this.$t("billing.1"),
        this.$t("billing.2"),
        this.$t("billing.3"),
        this.$t("billing.4"),
        this.$t("billing.5b"),
      ];
    },
  },

  methods: {
    see(url) {
      console.log(url);
      window.open(url);
    },
    go() {
      this.$router.go(-1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          var arr = this.ruleForm;
          console.log(arr);
          var obj = {
            currentBillId: this.currentBillId,
            billdetail: JSON.stringify(arr),
          };
          salechangeBillInfo(obj).then((res) => {
            if (res.data.code == "0") {
              this.dialogFormVisible = false;
              this.getData();
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    change(item, type) {
      console.log(type);
      if (type == "变更记录") {
        this.ruleForm = item.detail.parentDetail;
        this.disabledif = false;
        this.disabled = true;
      } else {
        this.disabled = false;
        this.disabledif = true;
        this.currentBillId = item.detail.id;
        (this.ruleForm.name = item.detail.name),
          (this.ruleForm.mobileno = item.detail.mobileno),
          (this.ruleForm.nationalId = item.detail.nationalId),
          (this.ruleForm.validFrom = item.detail.validFrom),
          (this.ruleForm.birthday = item.detail.birthday),
          (this.ruleForm.sex = item.detail.sex);
      }
      console.log(item);
    },

    fuzhiFun(id) {
      return new Promise((resove, reject) => {
        getPCActivateSign({ detailId: id })
          .then((res) => {
            resove(
              SEVERSEWM +
                "equitycard/toPcActivate?detailId=" +
                id +
                "&sign=" +
                res.data.obj
            );
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setTime(str) {
      return common.time(str);
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.eachPage = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.indexPage = (val - 1) * this.eachPage;
      console.log(val);
      this.getData();
    },
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      this.pageLoading = true;
      if (this.$route.query.type == "type") {
        orderbillDetail({ billDetailId: this.$route.query.id }).then((res) => {
          console.log(res);

          // this.divisionDay = res.data.obj.product.divisionDay
          this.creatData = res.data.obj;
          this.gridData = res.data.obj.scList;
          console.log(res.data.details);
          this.tableData = res.data.obj.details;
          this.allpage = res.data.obj.detailCount;
          var bTn = false;
          this.tableData.forEach((item, index) => {
            item.nowTime = new Date().getTime();
            item.copy = `${SEVERS}djxh5/#/introduceProduct?productId=${this.creatData.product.id}&code=${item.code}'&type=' + 1`;
            if (item.validFrom) {
              if (!item.serviceCredential) {
                bTn = true;
              }
            }
            console.log(this.creatData.product.productGroup);
            if (this.creatData.product.productGroup == "G74") {
              var a = item.resident.indexOf("_");
              item.resident = item.resident.substr(a + 1, item.resident.length);
              console.log(item.resident);
            }
          });
          if (bTn) {
            setTimeout(() => {
              this.getData();
            }, 2000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.pageLoading = false;
        });
      } else {
        var data = {
          billId: this.$route.query.id,
          start: this.indexPage,
          count: this.eachPage,
        };
        listByDetail(data)
          .then((res) => {
            // console.log(res)
            // console.log(res.data.obj.product.includeInsurance)
            // this.includeInsurance = res.data.obj.product.includeInsurance
            // console.log(this.includeInsurance)
            this.divisionDay = res.data.obj.product
              ? res.data.obj.product.divisionDay
              : null;
            this.creatData = res.data.obj;
            this.gridData = res.data.obj.scList;
            // console.log(res.data.obj2[0].product.periodType)
            // for(var i = 0; i<res.data.obj2.length; i++) {
            //    if(res.data.obj2[i].product.periodType == 1) {
            //      res.data.obj2[i].product.periodType = '年'
            //    }else if(res.data.obj2[i].product.periodType == 2){
            //      res.data.obj2[i].product.periodType = '月'
            //    }else {
            //      res.data.obj2[i].product.periodType = '日'
            //    }
            // }
            this.tableData = res.data.obj2;
            this.allpage = res.data.obj.detailCount;
            var bTn = false;
            this.tableData.forEach((item, index) => {
              item.parentDetail = [item.parentDetail];
              item.nowTime = new Date().getTime();
              item.copy = `${SEVERS}djxh5/#/introduceProduct?productId=${this.creatData.product.id}&code=${item.code}'&type=' + 1`;
              if (item.validFrom) {
                if (!item.serviceCredential) {
                  bTn = true;
                }
              }
              // console.log(this.creatData.product.productGroup )
              if (this.creatData.product.productGroup == "G74") {
                var a = item.resident.indexOf("_");
                item.resident = item.resident.substr(
                  a + 1,
                  item.resident.length
                );
                console.log(item.resident);
              }
            });
            // console.log(this.tableData)
            if (bTn) {
              setTimeout(() => {
                this.getData();
              }, 2000);
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.pageLoading = false;
          });
      }
    },
    sureExit() {
      var data = {
        // billId:this.$route.query.id,
        billDetailId: this.exitData.id,
      };
      refund(data)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: this.$t('dialog.refundSuccess'),
              type: "success",
            });
            this.centerDialogVisible1 = true;
          } else if (res.data.code == 105009) {
            this.$message.error(this.$t('dialog.refundActivatedFail'));
          } else if (res.data.code == 105014) {
            this.$message.error(this.$t('dialog.refundFail'));
          } else if (res.data.code == 105015) {
            this.$message.error(this.$t('dialog.refundPartialFail'));
          } else if (res.data.code == 105042) {
            this.$message.error(this.$t('dialog.refundPartialFail'));
          } else {
            this.$message.error(
              this.$tApiMsg(res.data.msg, res.data.code) || this.$t('dialog.refundFail')
            );
          }
          this.getData();
          this.centerDialogVisible = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    seachBox() {
      this.getData();
    },
    postCard() {
      var token = JSON.parse(window.localStorage.getItem("token")).data.obj
        .token;
      window.location = `${SEVERS}/rescue_sale/order/export?id=${this.$route.query.id}&token=${token}`;
    },
    tdDownPdf() {
      this.dialogTableVisible = true;
    },
    downPdf() {
      var loadingInstance = Loading.service({ fullscreen: true });
      const httpAxios = axios.create(); //创建实例
      httpAxios.defaults.timeout = 1000 * 60 * 2;
      httpAxios
        .get(API_BASE_EWM + "rescue_sale/sale/download_pdf", {
          params: {
            token: JSON.parse(window.localStorage.getItem("token")).data.obj
              .token,
            id: this.creatData.bill.id,
          },
        })
        .then((res) => {
          console.log(res);

          if (res.data.code == 0) {
            loadingInstance.close();
            window.location = res.data.obj;
          }
        })
        .catch((err) => {
          console.log(err);
          loadingInstance.close();
        });
    },
  },
  mounted() {
    this.getData();
    this.channeID = localStorage.getItem("channelId");
    const clipboard = new Clipboard(".icon-copy");
    clipboard.on("success", (e) => {
      this.$message.success(e.text + " 已复制到剪贴板！");
    });
    clipboard.on("error", (e) => {
      console.log("该浏览器不支持自动复制");
      clipboard.destroy();
    });
  },
};
</script>
<style>
.has-gutter th {
  background-color: #f5f7fb;
}
.sale-dialog {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(15, 35, 52, 0.18);
}
.sale-dialog .el-dialog__header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid #ebeef5;
  background: #f7f9fc;
}
.sale-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.sale-dialog .el-dialog__body {
  padding: 20px 24px;
  color: #606266;
}
.sale-dialog .el-dialog__footer {
  padding: 12px 20px 18px;
  border-top: 1px solid #ebeef5;
  background: #fafbfc;
}
.sale-dialog-tip {
  text-align: center;
  font-size: 16px;
  line-height: 1.6;
  color: #303133;
  padding: 12px 8px;
}
.sale-dialog-tip--warn {
  color: #e6a23c;
}
</style>
<style scoped="scoped">
.sale-detail-page {
  --sale-primary: #00abfa;
  --sale-text: #303133;
  --sale-muted: #909399;
  --sale-border: #ebeef5;
  --sale-bg: #f7f9fc;
  --sale-radius: 8px;
  color: var(--sale-text);
  height: 100%;
  max-height: calc(100vh - 94px);
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.sale-page-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid var(--sale-border);
  border-radius: var(--sale-radius);
  flex-shrink: 0;
}

.sale-page-header__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.sale-page-header__left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.sale-back-btn {
  flex-shrink: 0;
  margin-right: 6px;
  padding: 7px 14px !important;
  font-size: 14px;
  font-weight: 600;
  color: #00abfa !important;
  background: #e8f7fe !important;
  border: 1px solid #00abfa !important;
  border-radius: 4px;
}

.sale-back-btn:hover,
.sale-back-btn:focus {
  color: #fff !important;
  background: #00abfa !important;
  border-color: #00abfa !important;
}

.sale-page-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.sale-page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--sale-text);
  line-height: 1.3;
  white-space: nowrap;
}

.sale-page-desc {
  margin: 0;
  font-size: 13px;
  color: var(--sale-muted);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sale-panel {
  background: #fff;
  border: 1px solid var(--sale-border);
  border-radius: var(--sale-radius);
  overflow: hidden;
  margin-bottom: 10px;
}

.sale-panel--info {
  flex-shrink: 0;
}

.sale-panel--table {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.sale-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: var(--sale-bg);
  border-bottom: 1px solid var(--sale-border);
  font-size: 14px;
  font-weight: 600;
  color: var(--sale-text);
  flex-shrink: 0;
}

.sale-panel__count {
  font-size: 12px;
  font-weight: 400;
  color: var(--sale-muted);
}

.sale-info-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin: 0;
  padding: 6px 10px 2px;
  list-style: none;
  overflow: hidden;
}

.sale-info-grid > li {
  width: 33.33%;
  min-width: 240px;
  box-sizing: border-box;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #606266;
  font-size: 15px;
  line-height: 1.5;
}

.sale-info-grid > li > label,
.sale-info-grid > li > span > label {
  flex-shrink: 0;
  color: var(--sale-muted);
  min-width: 86px;
  font-size: 15px;
}

.sale-info-grid > li > span,
.sale-info-grid > li > a {
  color: var(--sale-text);
  word-break: break-all;
  font-size: 15px;
}

.sale-info-grid > li > span > span {
  color: var(--sale-text);
  font-size: 15px;
}

.sale-info-grid > li > a.blue,
.sale-info-grid > li > span.blue,
.sale-info-grid > li > span > span.blue {
  color: var(--sale-primary);
  cursor: pointer;
}

.sale-status {
  color: #e6a23c !important;
  font-weight: 600;
}

.sale-disabled-link {
  color: #c0c4cc;
}

.sale-panel--table .zsh,
.sale-panel--table .sale-table-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sale-panel--table .table {
  flex: 1;
  min-height: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.sale-panel--table .table >>> .el-table {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100% !important;
}

.sale-panel--table >>> .el-table th {
  color: #606266;
  font-weight: 600;
  background-color: #f5f7fb;
  font-size: 14px;
}

.sale-panel--table >>> .el-table td {
  font-size: 14px;
}

.fenye {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px 16px;
  border-top: 1px solid var(--sale-border);
  background: #fff;
  flex-shrink: 0;
}

.blue {
  color: var(--sale-primary);
  cursor: pointer;
}

.blue:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.searchBox {
  margin-top: 20px;
}

.input {
  width: 400px;
}

.copeA {
  cursor: pointer;
  color: #666;
}

.zsh {
  padding: 0;
}

.zsh > .table {
  flex: 1;
}

.zsh > div:not(.table) {
  flex-shrink: 0;
  margin: 0;
  padding: 6px 16px;
  font-size: 14px;
  color: #606266;
  border-top: 1px solid #f0f2f5;
}

@media (max-width: 900px) {
  .sale-info-grid > li {
    width: 50%;
    min-width: 0;
  }
}

@media (max-width: 600px) {
  .sale-info-grid > li {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/sale/orderDetails.vue